import { useState } from "preact/hooks";
import {
  GET,
  GET_CHANGE_DEVICE,
  GET_CHANGE_DEVICE_QURRY,
  GET_ITEM_CODE_MACHINE,
  GET_MACHINE_IMAGES,
} from "../../../services";
import { useMessage } from "../../../hooks/useMessage";
import { IStateChangeDevice } from "../interfaces/state";

export const useGetData = () => {
  const [data, setData] = useState([] as IStateChangeDevice[]);
  const [stateMachineImages, setStateMachineImages] = useState<
    { MaintainID: string; Url: string }[]
  >([]);
  const [optionMachines, setOptionMachines] = useState<
    { itemCode: string; itemName: string; versionMachine: string }[]
  >([]);
  const { openMessage } = useMessage();

  const onFetchData = async () => {
    try {
      const res = await GET(GET_CHANGE_DEVICE);
      const { data: d } = res.result;
      const items: IStateChangeDevice[] = d.map(
        (e: IStateChangeDevice, i: number) => ({
          ...e,
          index: i + 1,
        }),
      );
      setData(items);
    } catch (error) {
      console.log(error);
    }
  };

  const onSearch = async (qurryString: any) => {
    try {
      const res = await GET(GET_CHANGE_DEVICE_QURRY(qurryString));
      const { data: d } = res.result;
      const items: IStateChangeDevice[] = d.map(
        (e: IStateChangeDevice, i: number) => ({
          ...e,
          index: i + 1,
        }),
      );
      setData(items);
      if (d.length === 0) {
        openMessage("error", "ไม่พบข้อมูล");
      }
      if (d.length > 0) {
        openMessage("success", res.message);
      }
    } catch (error: any) {
      console.log(error);
      openMessage("error", error.message);
    }
  };

  const useGetItemCodeMachine = async (itemCode = "") => {
    try {
      const res = await GET(GET_ITEM_CODE_MACHINE(itemCode));
      const { machines } = res.result;
      setOptionMachines(machines ?? []);
      return machines ?? [];
    } catch (error) {
      console.log(error);
      setOptionMachines([]);
      return [];
    }
  };

  const useGetMachineImages = async (maintainId: string) => {
    try {
      const res: any = await GET(GET_MACHINE_IMAGES(maintainId));
      const { images } = res.data;
      setStateMachineImages(images ?? []);
    } catch (error) {
      console.log(error);
      setStateMachineImages([]);
    }
  };

  return {
    data,
    setData,
    onFetchData,
    onSearch,
    useGetItemCodeMachine,
    optionMachines,
    useGetMachineImages,
    stateMachineImages,
    setStateMachineImages,
  };
};
